import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import { Button, CircularProgress } from '@material-ui/core';

export const ActionButton = ({ variant, className, type, onClick, buttonLable, isLoading,disabled,fullWidth, ...props }) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            <Button
                variant={variant}
                className={className === 'cancel' ? classes.cancelButton : className === "deactive" ? classes.deactiveButton : classes.submitButton}
                type={type}
                onClick={onClick}
                disabled={disabled}
                fullWidth={fullWidth}
                >
                {isLoading && isLoading ? <span>{buttonLable}</span> : <span> <CircularProgress size={26} /></span>}
            </Button>
        </React.Fragment>
    )
}

ActionButton.propTypes = {
    variant: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    buttonLable: PropTypes.string.isRequired,
    className: PropTypes.string,
}